import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Lock } from "lucide-react";
import { api } from "@/lib/api";
import { ADMIN } from "@/constants/testIds";
import Logo from "@/components/Logo";

export default function AdminLogin() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const { data } = await api.post("/admin/login", { email, password });
            localStorage.setItem("gwb_admin_token", data.token);
            localStorage.setItem("gwb_admin_email", data.email);
            toast.success("Welcome back, Babur.");
            navigate("/admin/dashboard");
        } catch (err) {
            toast.error(err?.response?.data?.detail || "Invalid credentials.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-[#0A0A0A] px-5">
            <div className="w-full max-w-md">
                <div className="flex justify-center mb-10">
                    <Logo showTag />
                </div>
                <form onSubmit={submit} className="bg-[#141414] border border-white/10 p-10">
                    <div className="flex items-center gap-3 mb-8">
                        <Lock className="w-5 h-5 text-brand" />
                        <div className="eyebrow">Admin access</div>
                    </div>
                    <h1 className="font-display font-semibold text-3xl tracking-[-0.03em] text-white">Sign in.</h1>
                    <p className="text-white/50 text-sm mt-2">Restricted area — leads & payments dashboard.</p>

                    <div className="mt-8 space-y-5">
                        <div>
                            <label className="text-xs font-mono uppercase tracking-widest text-white/50 mb-2 block">Email</label>
                            <input
                                data-testid={ADMIN.emailInput}
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                                className="w-full bg-transparent border border-white/20 focus:border-brand outline-none text-white px-4 py-3 transition-colors"
                                placeholder="baburali514@gmail.com"
                            />
                        </div>
                        <div>
                            <label className="text-xs font-mono uppercase tracking-widest text-white/50 mb-2 block">Password</label>
                            <input
                                data-testid={ADMIN.passwordInput}
                                type="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                                className="w-full bg-transparent border border-white/20 focus:border-brand outline-none text-white px-4 py-3 transition-colors"
                                placeholder="••••••••"
                            />
                        </div>
                    </div>

                    <button
                        data-testid={ADMIN.loginBtn}
                        type="submit"
                        disabled={loading}
                        className="mt-8 w-full bg-brand hover:bg-brand-hover text-white font-semibold py-4 disabled:opacity-60 transition-colors"
                    >
                        {loading ? "Signing in..." : "Sign in"}
                    </button>
                </form>
                <p className="text-center text-xs text-white/30 font-mono mt-6 uppercase tracking-widest">
                    Grow With Babur — Admin Console
                </p>
            </div>
        </div>
    );
}
